export default __webpack_public_path__ + "static/media/Pedidos.7a81400e.svg";